var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderAccept(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M63.0123 32C63.0123 14.875 49.1248 0.987549 31.9998 0.987549C14.8748 0.987549 0.987305 14.875 0.987305 32C0.987305 49.1251 14.8748 63.0126 31.9998 63.0126C49.1248 63.0126 63.0123 49.1251 63.0123 32V32Z",
    fill: "#32BEA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M49.0751 21.6124C48.3501 19.7249 46.8626 20.0249 45.2501 20.3499C44.2876 20.5499 40.0001 21.7999 33.2376 28.9499C30.4251 31.9124 28.5751 34.2749 27.3501 36.0749C26.6001 35.1624 25.7501 34.1749 24.8501 33.2874C22.0876 30.5249 19.0001 28.6249 18.8751 28.5499C17.5876 27.7624 15.9001 28.1624 15.1001 29.4624C14.3126 30.7499 14.7126 32.4374 16.0001 33.2374C16.0251 33.2499 18.6751 34.8874 20.9501 37.1749C23.2751 39.4999 25.3876 42.6499 25.4126 42.6874C25.9251 43.4624 26.7876 43.9124 27.7001 43.9124C27.8501 43.9124 28.0126 43.8999 28.1751 43.8749C29.2501 43.6874 30.1001 42.8874 30.3626 41.8374C30.3751 41.8124 31.4626 38.7999 37.2001 32.7499C41.8251 27.8624 44.9126 26.3124 45.9876 25.8874C46.0001 25.8874 46.0001 25.8874 46.0251 25.8874C46.0251 25.8874 46.0626 25.8749 46.1251 25.8374C46.3126 25.7624 46.4126 25.7374 46.4126 25.7374C46.3626 25.7499 46.3376 25.7499 46.3376 25.7499V25.7374C46.8376 25.5249 47.7626 25.1249 47.7751 25.1124C49.1626 24.5124 49.6251 23.0124 49.0751 21.6124V21.6124Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAccept);
export default __webpack_public_path__ + "static/media/order_accept.a413e747810679ba9c9116f789976fc9.svg";
export { ForwardRef as ReactComponent };